import { Badge, Divider, Group, Stack, Text } from '@mantine/core';

const WidgetSection = ({
    title,
    value,
    badgeValue,
    rightSection,
    badgeProps = { size: 'sm', variant: 'light' },
    withDivider = true,
    ...groupProps
}) => {
    return (
        <>
            <Group
                justify={'space-between'}
                align={'center'}
                {...groupProps}>
                <Stack gap={0}>
                    <Text
                        fz='xs'
                        tt='uppercase'
                        fw={800}
                        c='dimmed'>
                        {title}
                    </Text>
                    <Text>{value}</Text>
                </Stack>

                {badgeValue ? (
                    <Badge {...badgeProps}>{badgeValue}</Badge>
                ) : null}

                {rightSection ? rightSection : null}
            </Group>
            {withDivider ? <Divider /> : null}
        </>
    );
};
export default WidgetSection;
